import React, { Component } from 'react';
import { Card, Modal, Col, Row, FormControl, FormLabel } from 'react-bootstrap';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import SemaforoFormatter from '../SalesFrequency/SemaforoFormatter';
import ReactTooltip from 'react-tooltip';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';

import selectStyles from '../../components/DropDown/selectStyles';
import dateFormat from '../../utils/date';
import SimpleModal from '../../components/Modal/SimpleModal';

import './styles.scss';

registerLocale('ptBR', ptBR);

const representativesToOptions = (representante) => ({
	label: representante,
	value: representante,
});

const selectField = {
	...selectStyles,
	control: (provided) => ({
		...provided,
		minWidth: 100,
		minHeight: 15,
		padding: 0,
	}),
	menu: (provided) => ({
		...provided,
		paddingTop: 0,
	}),
};

export class CustomerModal extends Component {
	render() {
		const { show, onClose, modalCustomer: customer } = this.props;
		const customerRepresentatives = customer.representatives
			? customer.representatives.map(representativesToOptions)
			: [];

		const ultimaCompraCor = customer
			? customer.lastPurchaseDate
				? customer.daysSinceLastPurchase < 180
					? '#39cd33'
					: '#eae825'
				: '#ff491c'
			: '#2a2c2d';
		const corAtraso = customer
			? customer.overdueTitles > 0
				? '#ff491c'
				: '#2a2c2d'
			: '#2a2c2d';

		// if(!customer) return (
		//   <div
		//     style={{
		//       display: 'flex',
		//       width: '100%',
		//       height: '100%',
		//       alignItems: 'center',
		//       justifyContent: 'center'
		//     }}
		//   >
		//     <Spinner
		//       size='xlarge'
		//     />
		//   </div>
		// )

		return (
			<SimpleModal
				isOpen={show}
				// onClose={onClose}
			>
				<div
					className="customerModal-container"
					style={{ width: '1000px', height: '550px' }}
				>
					<Modal.Header onHide={onClose} closeButton>
						<Modal.Title>{customer.name}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Card.Body>
							<Row>
								<Col md={6}>
									<FormLabel className="mt-2">Endereço</FormLabel>
									<FormControl
										value={
											customer
												? customer.address
													? customer.address
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={4}>
									<FormLabel className="mt-2">Cidade</FormLabel>
									<FormControl
										value={
											customer
												? customer.city
													? customer.city
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={2}>
									<FormLabel className="mt-2">Estado</FormLabel>
									<FormControl
										value={
											customer
												? customer.state
													? customer.state
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
							</Row>
							<Row>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">CEP</FormLabel>
									<FormControl
										value={
											customer
												? customer.zipCode
													? customer.zipCode
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Telefone</FormLabel>
									<FormControl
										value={
											customer
												? customer.telephone
													? customer.telephone
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Celular</FormLabel>
									<FormControl
										value={
											customer
												? customer.cellphone
													? customer.cellphone
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">
										Whats <i className="fa fa-whatsapp" />
									</FormLabel>
									<FormControl
										value={
											customer
												? customer.whats
													? customer.whats
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
							</Row>
							<Row>
								<Col md={6} xs={6}>
									<FormLabel className="mt-2">Email</FormLabel>
									<FormControl
										value={
											customer
												? customer.email
													? customer.email
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Insc. Estadual</FormLabel>
									<FormControl
										value={
											customer
												? customer.stateRegistration
													? customer.stateRegistration
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Suframa</FormLabel>
									<FormControl
										value={
											customer
												? customer.suframa
													? customer.suframa
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
							</Row>
							<Row>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Cadastro</FormLabel>
									<DatePicker
										placeholderText="Sem informação"
										className="form-control rounded-input"
										selected={
											customer
												? customer.registrationDate
													? new Date(
															dateFormat(
																customer.registrationDate,
																'YYYY/MM/DD',
															),
													  )
													: ''
												: ''
										}
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel
										className="mt-2"
										style={{ color: ultimaCompraCor }}
									>
										Última Compra
									</FormLabel>
									<DatePicker
										placeholderText="Sem informação"
										className="form-control rounded-input"
										selected={
											customer
												? customer.lastPurchaseDate
													? new Date(
															dateFormat(
																customer.lastPurchaseDate,
																'YYYY/MM/DD',
															),
													  )
													: ''
												: ''
										}
										locale="pt-BR"
										dateFormat="dd/MM/yyyy"
										readOnly
									/>
								</Col>
								<Col md={6} xs={6}>
									<FormLabel className="mt-2">Grupo Econômico</FormLabel>
									<FormControl
										value={
											customer
												? customer.economicGroup
													? customer.economicGroup
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
							</Row>
							<Row>
								<Col md={6} xs={6}>
									<FormLabel className="mt-2">Coleção Últ. Compra</FormLabel>
									<FormControl
										value={
											customer
												? customer.lastPurchaseCollection
													? customer.lastPurchaseCollection
													: 'Sem informação'
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={6} xs={6}>
									<FormLabel className="mt-2">
										Representante(s) customer
									</FormLabel>
									<Select
										placeholder="Nenhum representate..."
										noOptionsMessage={() => 'Nenhuma opção encontrada.'}
										styles={selectField}
										value={customerRepresentatives[0]}
										options={customerRepresentatives}
										onChange={() => {}}
										isDisabled
									/>
								</Col>
							</Row>
							<Row>
								<Col md={2} xs={2}>
									<FormLabel style={{ marginBottom: '11px' }}>Rota</FormLabel>
									<FormControl
										className="rounded-input"
										name="route"
										value={customer.route}
										readOnly
										placeholder="Sem informação"
									/>
								</Col>
								<Col md={4} xs={4}>
									<FormLabel className="mt-2">Sem. Financeiro</FormLabel>
									<SemaforoFormatter
										isLimitless
										value={customer ? customer.financialFlag : '5'}
										size={20}
									/>
									<ReactTooltip class="toolTip" />
								</Col>
								<Col md={6} xs={6}>
									<FormLabel className="mt-2">Valor Potêncial</FormLabel>
									<NumberFormat
										className="form-control"
										decimalScale={2}
										thousandSeparator="."
										decimalSeparator=","
										prefix={'R$'}
										fixedDecimalScale
										readOnly
										value={customer ? customer.salePotential : 0}
									/>
								</Col>
							</Row>
							<Row>
								<Col md={2} xs={2}>
									<FormLabel className="mt-2">Desconto</FormLabel>
									<FormControl
										value={
											customer
												? `${customer.averageDiscount}%`
												: 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={2} xs={2}>
									<FormLabel className="mt-2">Prazo</FormLabel>
									<FormControl
										value={
											customer ? customer.averageDeadline : 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={2} xs={2}>
									<FormLabel className="mt-2">Maior Atraso</FormLabel>
									<FormControl
										value={
											customer ? customer.daysGreatestDelay : 'Sem informação'
										}
										readOnly
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2">Títulos em Aberto</FormLabel>
									<NumberFormat
										className="form-control"
										decimalScale={2}
										thousandSeparator="."
										decimalSeparator=","
										prefix={'R$'}
										fixedDecimalScale
										readOnly
										value={customer ? customer.openTitles : 0}
									/>
								</Col>
								<Col md={3} xs={3}>
									<FormLabel className="mt-2" style={{ color: corAtraso }}>
										Títulos em Atraso
									</FormLabel>
									<NumberFormat
										className="form-control"
										decimalScale={2}
										thousandSeparator="."
										decimalSeparator=","
										prefix={'R$'}
										fixedDecimalScale
										readOnly
										value={customer ? customer.overdueTitles : 0}
									/>
								</Col>
							</Row>
						</Card.Body>
					</Modal.Body>
				</div>
			</SimpleModal>
		);
	}
}

export default CustomerModal;
